import i18n from "../i18n";

const CommunityChat = (app) => {
  app
    .post(
      "/community-chat/create-channel",
      async ({ req, res, flash, api, assert, locals }) => {
        const { body } = req;
        const { subject } = body;
        const { activeUser } = locals;

        assert(
          subject,
          400,
          i18n.t("coaching-portal:communityChatActions.provideChannelName")
        );

        const bodyToSend = {
          ...body,
          ownerId: String(activeUser._id),
        };

        try {
          await api(`create-chat-channel`, {
            method: "POST",
            body: bodyToSend,
          });

          flash(
            "success",
            i18n.t("coaching-portal:communityChatActions.channelCreatedSuccessfully")
          );
        } catch (e) {
          flash("error", e.message);
        }
        res.redirect("/coaching-portal/community-chat");
      }
    )
    .post("/community-chat/refresh", async ({ res }) => {
      res.backDontScroll();
    })
    .post(
      "/community-chat/modify-conversation",
      async ({ req, res, flash, api }) => {
        const { body } = req;
        try {
          await api(`modify-conversation`, {
            method: "PUT",
            body,
          });
          flash(
            "success",
            i18n.t(
              "coaching-portal:communityChatActions.conversationUpdatedSuccessfully"
            )
          );
        } catch (e) {
          flash("error", e.message);
        }
        res.refreshWith(
          { modal: "", conversationId: "" },
          { url: "back", hash: "#_" }
        );
      }
    )
    .post(
      "/community-chat/enable-pull-community-chat",
      async ({ res, flash, api }) => {
        try {
          await api("enable-pull-community-chat", {
            method: "POST",
            body: {},
          });
          flash(
            "success",
            i18n.t(
              "coaching-portal:communityChatActions.communityChatEnabled"
            )
          );
        } catch (e) {
          flash("error", e.message);
        }
        res.redirect(`/actions/preferences?type=pull`);
      }
    )
    .post(
      "/community-chat/disable-pull-community-chat",
      async ({ res, flash, api }) => {
        try {
          await api("disable-pull-community-chat", {
            method: "POST",
            body: {},
          });
          flash(
            "success",
            i18n.t(
              "coaching-portal:communityChatActions.communityChatDisabled"
            )
          );
        } catch (e) {
          flash("error", e.message);
        }
        res.redirect(`/actions/preferences?type=pull`);
      }
    )
    .post(
      "/community-chat/direct-message-toggle",
      async ({ req, res, flash, api, locals, assert }) => {
        const { activeUserToRequest } = locals;
        const { _id: userId, pushAccountInfo } = activeUserToRequest;
        const { body } = req;
        const { directMessagesEnabled } = body;
        assert(
          pushAccountInfo,
          400,
          i18n.t("coaching-portal:communityChatActions.needPushUser")
        );

        const bodyToSend = {
          pushAccountInfo: {
            ...pushAccountInfo,
            directMessagesEnabled,
          },
        };
        try {
          await api(`user/${userId}`, {
            method: "PUT",
            body: bodyToSend,
          });

          flash(
            "success",
            i18n.t(
              "coaching-portal:communityChatActions.directMessagePreferenceUpdated"
            )
          );
        } catch (e) {
          flash("error", e.message);
        }
        res.backDontScroll();
      }
    );
};

export default CommunityChat;
